import { ReactElement, useMemo } from 'react';
import { Box } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import { FilterRowsPanel } from '../filterGroupsPanel';
import { CreatePresetDialog } from './components/CreatePresetDialog';
import { FilterPanelLayout } from './components/FilterPanelLayout';
import { getFilterPanelRootSx } from './getFilterPanelRootSx';
import { useAutoScrollOnFilterAdd } from './hooks/useAutoScrollOnFilterAdd';
import { useFilterPresets } from './hooks/useFilterPresets';
import { useSidebarCollapse } from './hooks/useSidebarCollapse';
import { GridFilterPanelProps } from './types';

export function FilterPanelWrapper(props: GridFilterPanelProps): ReactElement {
  const {
    dataGridInstanceName,
    staticPresets,
    excludeFieldFromCount,
    getDefaultFilterItem,
    FilterForms = FilterRowsPanel,
    sx: filterPanelSx,
    ...gridFilterPanelProps
  } = props;
  const apiRef = useGridApiContext();

  const filterPanelRootSx = useMemo(
    () => getFilterPanelRootSx(filterPanelSx),
    [filterPanelSx]
  );

  const { formsAreaRef } = useAutoScrollOnFilterAdd(apiRef);
  const { collapsed, toggle } = useSidebarCollapse();

  const presetState = useFilterPresets({
    apiRef,
    dataGridInstanceName,
    staticPresets,
    excludeFieldFromCount,
    getDefaultFilterItem,
  });

  if (!dataGridInstanceName) {
    return (
      <Box sx={filterPanelRootSx}>
        <FilterForms {...gridFilterPanelProps} />
      </Box>
    );
  }

  return (
    <>
      <FilterPanelLayout
        formsAreaRef={formsAreaRef}
        sidebarCollapsed={collapsed}
        onToggleSidebar={toggle}
        presetState={presetState}
        excludeFieldFromCount={excludeFieldFromCount}
        filterPanelSx={filterPanelSx}
        FilterForms={FilterForms}
        gridFilterPanelProps={gridFilterPanelProps}
      />

      <CreatePresetDialog
        open={presetState.isDialogOpen}
        isRenameMode={presetState.isRenameMode}
        presetName={presetState.dialogPresetName}
        onPresetNameChange={presetState.setDialogPresetName}
        onClose={presetState.closeDialog}
        onSubmit={presetState.submitDialog}
      />
    </>
  );
}
